var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.6355 12C6.6355 14.9823 9.077 17.4 12.0888 17.4C14.4631 17.4 16.4831 15.8974 17.2317 13.8H12.0888V10.2H21V13.8H20.9957C20.1536 17.908 16.4858 21 12.0888 21C7.06917 21 3 16.9705 3 12C3 7.02943 7.06917 3 12.0888 3C15.2198 3 17.9811 4.5678 19.6156 6.95386L16.6367 9.01934C15.6603 7.56131 13.9878 6.6 12.0888 6.6C9.077 6.6 6.6355 9.01766 6.6355 12Z"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }